import React, { PureComponent } from 'react'
import _ from 'lodash'
// import {COLORS, STYLES} from '../config/styles'
// import { log, setStatePromise } from 'x/utils/util'

import { StatusBar, StatusBarProps, Platform } from 'react-native'
import { SystemBars, SystemBarsEntry } from 'react-native-edge-to-edge'

// // const STATUS_BAR_BG_COLOR = 'grey'
// const STATUS_BAR_BG_COLOR = '#fff'
// const STATUS_BAR_TEXT_STYLE = 'dark-content'

export default class XStatusBar extends PureComponent<StatusBarProps> {
  static displayName = 'XStatusBar'

  // systemBarsStackEntry?: SystemBarsEntry

  // componentDidMount() {
  //   if (Platform.OS === 'web') {
  //     return
  //   }
  //   this.delayToInit()
  // }

  // componentWillUnmount() {
  //   if (Platform.OS === 'web') {
  //     return
  //   }

  //   if (!_.isNil(this.systemBarsStackEntry)) {
  //     SystemBars.popStackEntry(this.systemBarsStackEntry)
  //   }
  // }

  // delayToInit = async () => {
  //   if (Platform.OS === 'web') {
  //     return
  //   }
  //   await new Promise((resolve) => setTimeout(resolve, 5000))

  //   const { hidden = false, translucent = false } = this.props
  //   let isHidden = translucent
  //   if (_.isBoolean(hidden)) {
  //     isHidden = hidden
  //   }

  //   this.systemBarsStackEntry = SystemBars.pushStackEntry({ hidden: isHidden })

  //   await new Promise((resolve) => setTimeout(resolve, 5000))
  // }

  render() {
    if (Platform.OS === 'web') {
      return null
    }

    const { hidden = false, translucent = false } = this.props

    // let isHidden = translucent
    // if (_.isBoolean(hidden)) {
    //   isHidden = hidden
    // }

    // return <StatusBar hidden={hidden} translucent={translucent} showHideTransition={'none'} animated={false} barStyle='light-content' />

    return <SystemBars style='auto' hidden={hidden} />

    // return (
    //   <StatusBar
    //     hidden={false}
    //     showHideTransition='slide'
    //     translucent={false}
    //     backgroundColor={STATUS_BAR_BG_COLOR}
    //     barStyle={STATUS_BAR_TEXT_STYLE}
    //     {...this.props}
    //   />
    // )
  }
}
